import React from 'react'
import CustomButton from '../../components/common/CustomButton/CustomButton'
import Text from '../../components/typography/Text'
import Grid from '../../components/layout/grid/Grid'
import CustomTextInputBasic from '../../components/common/CustomTextInput/CustomTextInputBasic'

const AdvisorProfileTab = ({data}) => {
  console.log('profiledd',data);

  
  return (
    <div className="flex flex-col p-4 bg-white border border-gray-200 rounded-md mt-4">
        <Text className="!font-bold mb-2">Personal Details</Text>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <CustomTextInputBasic
              name="name"
              label="Name"
              value={data?.name}
              disabled
            />
          </Grid>
          <Grid item xs={4}>
            <CustomTextInputBasic
              name="email"
              label="Email"
              value={data?.email}
              disabled
            />
          </Grid>
          <Grid item xs={4}>
            <CustomTextInputBasic
              name="mobile"
              label="Mobile"
              value={data?.email}
              disabled
            />
          </Grid>
          <Grid item xs={4}>
            <CustomTextInputBasic
              name="qualification"
              label="Qualification"
              value={data?.qualification}
              disabled
            />
          </Grid>
          <Grid item xs={4}>
            <CustomTextInputBasic
              name="aadharCard"
              label="Aadhar Card"
              value={data?.aadhar_card_number}
              disabled
            />
          </Grid>
          <Grid item xs={4}>
            <CustomTextInputBasic
              name="panCard"
              label="PAN Card"
              value={data?.pan_card_number}
              disabled
            />
          </Grid>
        </Grid>

        <Text className="!font-bold mt-4 mb-2">Bank Details</Text>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <CustomTextInputBasic
              name="accountName"
              label="Account Name"
              value={data?.bank_details[0]?.bank_name}
              disabled
            />
          </Grid>
          <Grid item xs={4}>
            <CustomTextInputBasic
              name="accountNumber"
              label="Account Number"
              value={data?.bank_details[0]?.bank_account_number}
              disabled
            />
          </Grid>
          <Grid item xs={4}>
            <CustomTextInputBasic
              name="bankName"
              label="Bank Name"
              value={ Array.isArray(data?.bank_details) ? data.bank_details[0]?.bank_name : "" }
              disabled
            />
          </Grid>
          <Grid item xs={6}>
            <CustomTextInputBasic
              name="branch"
              label="Branch"
              value={Array.isArray(data?.bank_details) ? data.bank_details[0]?.bank_branch : ""}
              disabled
            />
          </Grid>
          <Grid item xs={6}>
            <CustomTextInputBasic
              name="ifscCode"
              label="IFSC Code"
              value={Array.isArray(data?.bank_details) ? data.bank_details[0]?.bank_ifsc_code : ""}
              disabled
            />
          </Grid>
        </Grid>

        {/* Action Buttons */}
        {/* <div className="flex justify-end mt-4">
          <CustomButton
            type="button"
            variant="default"
            label="Reject"
            onClick={() => setIsReject(true)}
            className="mr-2"
            disabled={isActionDisabled}
          />
          <CustomButton
            type="submit"
            variant="primary"
            label="Approve"
            disabled={isActionDisabled}
          />
        </div> */}
      </div>
  )
}

export default AdvisorProfileTab